import React, { Component, Suspense, lazy } from "react";

const LazyGrid = lazy(() => import("./Grid"));
const LazyButton = lazy(() => import("./Button"));
const LazyHeading = lazy(() => import("./Heading"));
const LazyText = lazy(() => import("./Text"));
const LazyImage = lazy(() => import("./Image"));
const LazyDivider = lazy(() => import("./Divider"));
const LazyColumn = lazy(() => import("./Column"));
const LazyScmInput = lazy(() => import("./ScmInput"));
const LazyScmOutput = lazy(() => import("./ScmOutput"));
const LazyScmIf = lazy(() => import("./ScmIf"));
const LazyScmElseIf = lazy(() => import("./ScmElseIf"));
const LazyScmDecision = lazy(() => import("./ScmDecision"));
const LazyScmDataTable = lazy(() => import("./ScmDataTable"));

class SwitchElements extends Component {
  render() {
    const { type } = this.props;

    const paramState = {
      ...this.props,
    };

    return (
      <Suspense fallback={<div>Loading...</div>}>
        {(() => {
          switch (type) {
            case "Grid":
              return <LazyGrid {...paramState} />;
            case "Heading":
              return <LazyHeading {...paramState} />;
            case "Text":
              return <LazyText {...paramState} />;
            case "Image":
              return <LazyImage {...paramState} />;
            case "Button":
              return <LazyButton {...paramState} />;
            case "Divider":
              return <LazyDivider {...paramState} />;
            case "Column":
              return <LazyColumn {...paramState} />;
            case "SCM:INPUT":
              return <LazyScmInput {...paramState} />;
            case "SCM:OUTPUT":
              return <LazyScmOutput {...paramState} />;
            case "SCM:IF":
              return <LazyScmIf {...paramState} />;
            case "SCM:ELSEIF":
              return <LazyScmElseIf {...paramState} />;
            case "SCM:DECISION":
              return <LazyScmDecision {...paramState} />;
            case "SCM:DATATABLE":
              return <LazyScmDataTable {...paramState} />;
            default:
              return null;
          }
        })()}
      </Suspense>
    );
  }
}

SwitchElements.defaultProps = {
  screen: "Layout",
};

export default SwitchElements;

// import React, { Component } from "react";
// import Grid from "./Grid";
// import Button from "./Button";
// import Heading from "./Heading";
// import Text from "./Text";
// import Image from "./Image";
// import Divider from "./Divider";
// import Column from './Column';
// import ScmInput from './ScmInput';
// import ScmOutput from './ScmOutput';
// import ScmIf from './ScmIf';
// import ScmElseIf from './ScmElseIf';
// import ScmDecision from './ScmDecision';
// import ScmDataTable from './ScmDataTable';
// // import { findClosestSelectableElement } from "../../HTMLBuilderfunction";

// class SwitchElements extends Component {
//   // constructor(props) {
//   //   super(props);
//   //   this.state = {
//   //     currentId:null
//   //   }
//   // }
//   render() {
//     const {type} = this.props;
    

    
   

//     const paramState = {
//       ...this.props,
//       // ...this.props.eventProps,
//       // eventDefProps:eventDefProps,
//       // currentId:this.state.currentId,
//       // currentElementData:currentElementData,
//     }
//     //console.log('paramState',paramState);
//     // const html5Props = {
//     //   handleDragLeave:handleDragLeave,
//     //   handleDragStart:handleDragStart
//     // }
//     //console.log('type==',type)
//     switch (type) {
//         case "Grid":
//             return <Grid  {...paramState} />;
//         case "Heading":
//             return <Heading  {...paramState} />;
//         case "Text":
//             return <Text  {...paramState} />;
//         case "Image":
//             return <Image  {...paramState} />;
//         case "Button":
//             return <Button  {...paramState} />;
//         case "Divider":
//             return <Divider {...paramState}/>;
//         case "Column":
//             return <Column {...paramState}/>;
//         case "SCM:INPUT":
//             return <ScmInput {...paramState}/>;
//         case "SCM:OUTPUT":
//             return <ScmOutput {...paramState}/>; 
//         case "SCM:IF":
//             return <ScmIf {...paramState}/>;
//         case "SCM:ELSEIF":
//             return <ScmElseIf {...paramState}/>;
//         case "SCM:DECISION":
//             return <ScmDecision {...paramState}/>;
//         case "SCM:DATATABLE":
//             return <ScmDataTable {...paramState}/>;                       
//         default:
//             return false;
        
//     }
//   }
  
// }

   
   

// SwitchElements.defaultProps = {
//   screen: "Layout",
// }

// export default SwitchElements;

 
